const markdownConfig = {
  id: 'markdown-container',

  // externals: {
  //   echarts: window.echarts,
  //   katex: window.katex,
  //   MathJax: window.MathJax,
  // },
  isPreviewOnly: false,
  engine: {
    global: {
      // urlProcessor(url, srcType) {
      //   console.log(`url-processor`, url, srcType)
      //   return url
      // }
    },
  },
  // multipleFileSelection: {
  //   video: true,
  //   audio: false,
  //   image: true,
  //   word: false,
  //   pdf: true,
  //   file: true
  // },
  toolbars: {
    toolbar: [
      'bold',
      'italic',
      'size',
      '|',
      'color',
      'header',
      // '|',
      // 'drawIo',
      '|',
      'ol',
      'ul',
      'checklist',
      'panel',
      'justify',
      'detail',
      '|',
      'formula',
      {
        insert: [
          // 'image',
          // 'audio',
          // 'video',
          'link',
          'hr',
          'br',
          'code',
          'inlineCode',
          'formula',
          'toc',
          'table',
          // 'pdf',
          // 'word',
          // 'file'
        ],
      },
      'graph',
      // 'togglePreview',
      // 'settings',
      // 'codeTheme',
      'export',
      // 'theme'
    ],
    toolbarRight: [
      'fullScreen',
      //  '|', 'changeLocale', 'wordCount'
    ],
    bubble: ['bold', 'italic', 'underline', 'strikethrough', 'sub', 'sup', 'quote', 'ruby', '|', 'size', 'color'], // array or false
    // sidebar: ['copy', 'theme'],
    shortcutKeySettings: {
      /** 是否替换已有的快捷键, true: 替换默认快捷键； false： 会追加到默认快捷键里，相同的shortcutKey会覆盖默认的 */
      isReplace: false,
      shortcutKeyMap: {
        'Alt-Digit1': {
          hookName: 'header',
          aliasName: '标题',
        },
        'Control-Shift-KeyX': {
          hookName: 'bold',
          aliasName: '加粗',
        },
      },
    },
  },
  // drawioIframeUrl: './drawio_demo.html',
  previewer: {
    // 自定义markdown预览区域class
    // className: 'markdown'
    floatWhenClosePreviewer: true,
  },
  keydown: [],
  //extensions: [],
  // fileUpload(file, callback) {
  //   try {
  //     // TODO:上传接口
  //     materialApi
  //       .upload({
  //         File: file
  //       })
  //       .then((res) => {
  //         callback(res.url)
  //       })
  //   } catch (error) {}
  // },
  callback: {},
  editor: {
    id: 'cherry-text',
    name: 'cherry-text',
    autoSave2Textarea: true,
    defaultModel: 'edit&preview',
    showFullWidthMark: true, // 是否高亮全角符号 ·|￥|、|：|“|”|【|】|（|）|《|》
    showSuggestList: true, // 是否显示联想框
    codemirror: {
      autofocus: false,
    },
  },
  // cherry初始化后是否检查 location.hash 尝试滚动到对应位置
  autoScrollByHashAfterInit: true,
};
const config = {
  id: 'markdown-container',
};
export default markdownConfig;
// export default markdownConfig
/**
 * 上传文件函数
 * @param file 上传文件的文件对象
 * @param callback 回调函数，回调函数接收两个参数，第一个参数为文件上传后的url，第二个参数可选，为额外配置信息
 */
function myFileUpload(file, callback) {
  // 先把文件上传到服务端，上传文件的具体代码需要自行实现
  console.log('upload file', file);
}
